"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/click-events-have-key-events */
const react_1 = __importStar(require("react"));
const Portal_1 = require("~/components/UI/Portal");
const useClickOutsideHandler_1 = __importDefault(require("~/hooks/useClickOutsideHandler"));
const useScrollOutsideHandler_1 = __importDefault(require("~/hooks/useScrollOutsideHandler"));
const utils_1 = require("./utils");
function Tooltip(_a) {
    var { activeStateHandler, children, contentNode, placement = 'bottom-start', showOn = 'hover', customChildrenStyle, hideOnSelect = true, disabled = false } = _a, props = __rest(_a, ["activeStateHandler", "children", "contentNode", "placement", "showOn", "customChildrenStyle", "hideOnSelect", "disabled"]);
    const [tooltipTop, setTooltipTop] = (0, react_1.useState)(0);
    const [tooltipLeft, setTooltipLeft] = (0, react_1.useState)(0);
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const [elementMarginTop, setElementMarginTop] = (0, react_1.useState)(0);
    const [tooltipRef, setTooltipRef] = (0, react_1.useState)();
    const [childrenRef, setChildrenRef] = (0, react_1.useState)();
    const wrapperRef = (0, react_1.useRef)(null);
    const elementRef = (0, react_1.useRef)(null);
    (0, react_1.useMemo)(() => {
        if (!childrenRef || !tooltipRef) {
            return;
        }
        const { tooltipLeft: tooltipLeftPosition, tooltipTop: tooltipTopPosition } = (0, utils_1.calculateTooltipPosition)(childrenRef.getBoundingClientRect(), tooltipRef.getBoundingClientRect(), placement);
        setTooltipLeft(tooltipLeftPosition);
        setTooltipTop(tooltipTopPosition);
    }, [placement, childrenRef, tooltipRef]);
    const mouseEnterHandler = () => setShowTooltip(true);
    const mouseLeaveHandler = () => setShowTooltip(false);
    const hideOrShowTooltip = () => setShowTooltip(!showTooltip);
    const onClickHandler = () => {
        if (hideOnSelect) {
            hideOrShowTooltip();
        }
    };
    const hideTooltip = () => setShowTooltip(false);
    const onKeyDownHandler = (event) => {
        if (event.key === 'Enter' || event.key === 'Accept' || event.key === ' ') {
            setShowTooltip(!showTooltip);
        }
    };
    let handlers = {};
    switch (showOn) {
        case 'hover':
            handlers = { onPointerEnter: mouseEnterHandler, onPointerLeave: mouseLeaveHandler };
            break;
        case 'click':
            handlers = { onClick: onClickHandler, onKeyDown: onKeyDownHandler };
            break;
        default:
            break;
    }
    const childrenWithProps = react_1.Children.map(children, (child) => {
        if ((0, react_1.isValidElement)(child) && 'ref' in child) {
            return (0, react_1.cloneElement)(child, Object.assign(Object.assign({}, handlers), { ref: (ref) => setChildrenRef(ref) }));
        }
        return child;
    });
    (0, useClickOutsideHandler_1.default)(wrapperRef, elementRef, hideTooltip);
    (0, useScrollOutsideHandler_1.default)(wrapperRef, elementRef, hideTooltip);
    (0, react_1.useEffect)(() => {
        if (activeStateHandler && !disabled) {
            activeStateHandler(showTooltip);
        }
    }, [showTooltip, activeStateHandler, disabled]);
    const calculateElementMarginTop = (element) => {
        if (!element) {
            return 0;
        }
        const elementRect = element.getBoundingClientRect();
        const elementHeight = elementRect.height;
        const elementBottom = elementRect.bottom;
        const windowHeight = window.innerHeight;
        const isOverflowing = windowHeight < elementBottom;
        return isOverflowing ? -elementHeight + 20 : 0;
    };
    (0, react_1.useEffect)(() => {
        setElementMarginTop(calculateElementMarginTop(tooltipRef));
    }, [tooltipRef]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        showTooltip && !disabled ? (react_1.default.createElement(Portal_1.Portal, null,
            react_1.default.createElement("div", { ref: wrapperRef },
                react_1.default.createElement("div", Object.assign({ ref: (ref) => setTooltipRef(ref), "data-testid": "tooltip", style: Object.assign({ position: 'absolute', transform: `translate(${tooltipLeft}px, ${tooltipTop}px)`, pointerEvents: 'all' }, (elementMarginTop !== 0 && { marginTop: `${elementMarginTop}px` })), "data-placement": placement }, handlers, props), contentNode)))) : null,
        react_1.default.createElement("div", { style: customChildrenStyle, ref: elementRef, onClick: showOn === 'click' && !hideOnSelect ? hideOrShowTooltip : undefined }, childrenWithProps)));
}
exports.default = Tooltip;
